<template>
  <div class="row pl-3 pr-3">
    <div class="col-main">
      <!-- 左侧 -->
      <div class="col-left card">
        <div class="col-left-top">
          <div class="float-left"></div>
          <div @click="shrinkMenu" class="hidden-icon">
            <i :class="collapse ? 'el-icon-s-unfold': 'el-icon-s-fold'"></i>
          </div>
        </div>
        <el-menu class="el-menu-vertical" :collapse="collapse">
          <div class="col-left-panel" :hidden="collapse">
            <div class="item_head">
              <h5 class="item_h5">角色列表</h5>
              <el-button type="primary" size="small" @click="dlg_add_role = true" class="item_btn">添加角色</el-button>
            </div>
            <el-divider></el-divider>
            <ul class="pl-0 panel_ul">
              <li v-for="(item,index) in roles" @click="groupChange(item,index)" :key="index"
                  :class="{active: isActive === index}"
                  :index="(1+index).toString()">
                <i class="el-icon-menu"></i>
                <span slot="title">{{ item.remark }}</span>
                <span stye="float:right;">
									<i class="el-icon-delete item_icon" @click="handleDeleteRole(index,item)"></i>
									<i class="el-icon-edit item_icon" @click="handleEditRole(index,item)"></i>
                </span>
              </li>
            </ul>
          </div>
        </el-menu>
      </div>

      <div class="col-right">
        <div class="card">
          <el-card shadow="never">
            <div class="content-box">
              <div class="title">权限管理
              </div>
              <div class="content">
                <label class="item_w">角色：</label>
                <label class="item_w">用户数：{{ this.page.total }}人</label>
              </div>
              <div class="content">
                <el-button type="primary" @click="dlg_grant = true">用户授权
                </el-button>
              </div>
            </div>
          </el-card>
        </div>

        <div class="card">
          <div class="card-block">
            <el-pagination layout="total, prev, pager, next" @current-change="handleCurrentChange"
                           :page-size="page.size" :current-page="page.index+1" :total="page.total"
                           style="float:right;">
            </el-pagination>
            <!--
            <el-table stripe :data="roles" border highlight-current v-loading="listLoading"
                      @selection-change="selsChange" style="width: 100%;">
              <el-table-column type="selection">
              </el-table-column>
              <el-table-column prop="name" label="名称">
              </el-table-column>
              <el-table-column prop="remark" label="描述">
              </el-table-column>
              <el-table-column label="操作" width="180px">
                <template slot-scope="scope">
                  <el-button-group>
                    <el-button @click="handleEdit(scope.$index, scope.row)" size="mini">编辑
                    </el-button>
                    <el-button @click="handleEdit(scope.$index, scope.row)" size="mini">查看
                    </el-button>
                  </el-button-group>
                </template>
              </el-table-column>
            </el-table>
            -->

            <el-table stripe :data="users" border highlight-current v-loading="listLoading"
                      @selection-change="selsChange">
              <el-table-column type="selection"></el-table-column>
              <el-table-column prop="name" label="用户名"></el-table-column>
              <el-table-column prop="phone" label="手机号"></el-table-column>
              <el-table-column prop="email" label="email"></el-table-column>
              <el-table-column prop="groupName" label="团队名">
                <template slot-scope="scope">
                  <div v-if="scope.row.groupId!=0">
                    {{ scope.row.groupName }}
                  </div>
                  <div v-else>
                    <el-tag type="primary" @click="show_add_group(scope.row)" style="cursor: pointer">添加团队
                    </el-tag>
                  </div>
                </template>
                dlg_add_group
              </el-table-column>
              <el-table-column prop="lastLogin" label="最近登录时间">
                <template slot-scope="scope">
                  {{ scope.row.lastLogin | formatDateTime }}
                </template>
              </el-table-column>
              <el-table-column prop="active" label="在线" width="60px">
                <template slot-scope="scope">
                  <el-button v-if="scope.row.active=='1'" circle type="info">
                  </el-button>
                  <el-button v-if="scope.row.active==null || scope.row.active==0" circle
                             type="primary">
                  </el-button>
                </template>
              </el-table-column>
              <el-table-column label="角色">
                <template slot-scope="scope">
                  <div v-for="role in scope.row.roles">
                    {{ role }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="启用／停用" width="100px">
                <template slot-scope="scope">
                  <el-button-group>
                    <el-button v-if="scope.row.active=='1'" size="mini"
                               @click="activeUser(scope.row,false)">停用
                    </el-button>
                    <el-button type="primary"
                               v-if="scope.row.active==null || scope.row.active==0" size="mini"
                               @click="activeUser(scope.row,true)">启用
                    </el-button>
                  </el-button-group>
                </template>
              </el-table-column>
            </el-table>

            <el-pagination layout="total, prev, pager, next" @current-change="handleCurrentChange"
                           :page-size="page.size" :current-page="page.index+1" :total="page.total"
                           style="float:right;">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>

    <el-dialog title="添加角色" :visible.sync="dlg_add_role" :close-on-click-modal="false" size="tiny" width="500px">
      <el-form :model="addForm" label-width="90px" ref="addForm" style="padding-right:50px;">
        <el-form-item label="角色名" prop="name">
          <el-input v-model="addForm.name" auto-complete="off">
          </el-input>
        </el-form-item>
        <el-form-item label="角色描述" prop="remark">
          <el-input v-model="addForm.remark" auto-complete="off">
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click.native="addSubmit" type="primary" :loading="addLoading">确定添加</el-button>
          <el-button @click.native="dlg_add_role = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog title="角色授权" :visible.sync="dlg_grant" :close-on-click-modal="false" width="800px">
      <el-form :model="addForm" label-width="100px" ref="addForm">
        <el-form-item label="用户名" prop="name">
          <el-row>
            <el-col :span="20">
              <!--<el-input v-model="addForm.name" auto-complete="off" >
                <el-button slot="append" icon="search" @click="search_user"></el-button>
              </el-input>-->
              <el-select v-model="selectedUserId" @change="search_user" filterable placeholder="请选择">
                <el-option v-for="item in users" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="角色列表">
          <el-row>
            <el-col :span="24">
              <el-transfer v-model="selectedUser.roles" :titles="['未选', '已选']" :props="{
                              key: 'name',
                              label: 'name'
                            }" :data="roles"></el-transfer>
            </el-col>
          </el-row>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="dlg_grant = false">取消</el-button>
        <el-button @click.native="update_user_role" type="primary" :loading="addLoading">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from '../../api/rest'

export default {
  name: 'tables',
  data() {
    return {
      // 新增界面数据
      addForm: {
        name: '',
        role_name: '',
        remark: ''
      },
      roles: [],
      users: [],
      page: {
        total: 0,
        index: 0,
        size: 10
      },
      listLoading: false,
      addLoading: false,
      sels: [], // 列表选中列
      editFormVisible: false, // 编辑界面是否显示
      editLoading: false,
      dlg_add_role: false,
      dlg_grant: false,
      largeModal: false,
      smallModal: false,
      primaryModal: false,
      successModal: false,
      warningModal: false,
      dangerModal: false,
      infoModal: false,
      selectedUserId: '',
      selectedUser: [],
      isActive: -1,
      collapse: api.storage.get('isCollapse'),
    }
  },
  methods: {
    shrinkMenu() {
      this.collapse = !this.collapse;
      api.storage.set('isCollapse', this.collapse);
    },
    groupChange(value, index) {
      this.isActive = index;
      let api_url = "/user/getUserByRole"
      let loadData = {
        roleId: value.id
      }
      let param = {
        ...this.page,
        ...loadData
      }
      this.listLoading = true
      api.remote.doPost(param, api_url).then((res) => {
        this.page.total = res.totalElements
        this.users = res.content
        this.listLoading = false
      }).catch((res) => {
        this.listLoading = false
        api.handError.action(this, res)
      })
    },
    handleDeleteRole(index, item) {

    },
    handleEditRole(index, item) {
      this.addForm = item;
      this.dlg_add_role = true;
    },
    handleCurrentChange(val) {
      this.page.index = val - 1
    },
    // 获取用户组列表
    getRoles() {
      this.listLoading = true
      api.admin.roleList(this.page.index, this.page.size).then((res) => {
        this.roles = res.content
        this.listLoading = false
      }).catch((res) => {
        this.listLoading = false
        api.handError.action(this, res)
      })
    },
    getUsers() {
      let api_url = "/sys/listUser"
      let para = this.page
      api.remote.doPost(para, api_url).then((res) => {
        this.page.total = res.totalElements
        this.users = res.content
      }).catch((res) => {
        api.handError.action(this, res)
      })
    },
    search_user: function (param) {
      for (var i in this.users) {
        if (this.users[i].id === param) {
          this.selectedUser = this.users[i]
        }
      }
    },
    // 更新用户角色
    update_user_role: function () {
      api.admin.update_user_role(this.selectedUser).then((res) => {
        this.addLoading = false
        this.$message({
          title: res.title,
          message: res.message,
          type: res.status
        })
        this.getUsers()
      }).catch((res) => {
        api.handError.action(this, res)
      })
    },
    // 新增用户
    addSubmit: function () {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.addLoading = true
          let para = Object.assign({}, this.addForm)
          api.admin.roleAdd(para).then((res) => {
            this.addLoading = false
            this.$message({
              title: res.title,
              message: res.message,
              type: res.status
            })
            this.dlg_add_role = false
            this.getRoles()
          }).catch((res) => {
            api.handError.action(this, res)
          })
        }
      })
    },
    // 编辑
    handleEdit: function (index, row) {
      this.dlg_add_role = true
      var userEdit = row
      this.addForm = Object.assign({}, userEdit)
    },
    // 批量删除
    batchRemove: function () {
      var models = this.sels.map(item => item)
      this.$confirm('确认删除选中记录吗？', '提示', {
        type: 'warning'
      }).then(() => {
        this.listLoading = true
        let para = models
        api.admin.delRole(para).then((res) => {
          this.listLoading = false
          this.$message({
            title: res.title,
            message: res.message,
            type: res.status
          })
          this.getRoles()
        })
      }).catch((res) => {
        api.handError.action(this, res)
      })
    },
    // 启用／停用用户
    activeUser: function (row, enabled) {
      let data = row
      if (enabled === true) {
        data.active = 1
      } else {
        data.active = 0
      }
      api.admin.enabledUser(data).then((res) => {
      }).catch((res) => {
        api.handError.action(this, res)
        if (enabled === true) {
          data.active = 0
        } else {
          data.active = 1
        }
        api.handError.action(this, res)
      })
    },
    selsChange: function (sels) {
      this.sels = sels
    }
  },
  filters: {
    formatDateTime(time) {
      var date = new Date(time)
      return date.toLocaleString()
    }
  },
  mounted() {
    // this.$router.push({ path: '/login' })
    this.getUsers()
    this.getRoles()
  }
}
</script>



// WEBPACK FOOTER //
// Roles.vue?4f6ed00c